module.exports = __webpack_public_path__ + "img/quickresume1.516bd0d8.png";